import copyToClipboard from "copy-to-clipboard";
import {message} from "antd";

export const copyPathToClipboard = (path, optionalMessage) => {
    const a = document.createElement("a");
    a.href = path;
    copyToClipboard(a.href);
    message.success(optionalMessage || "Link copied to clipboard successfully!", 5);
};
